module.exports = __webpack_public_path__ + "static/media/habbit-tracker3.f10e3aca.jpg";